import './NonMfaWhatsappPreference.css';
import i18n from '../../i18n';
import {updateNonMfaWhatsAppOptIn} from '../../redux/actions/actions';
import CustomCard from '../custom_card/CustomCard';
import WhatsappOptinTnc from '../whatsappOptin_tnc/WhatsappOptinTnc';

import {Button} from '@deere/ux.uxframe-react';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

const WhatsappCardHeader = () => (
  <h5>{i18n.t('STAY_CONNECTED_ON_WHATSAPP')}</h5>
);

const WhatsappDisclaimerContent = () => (
  <>
    <div>
      <span>{i18n.t('DEAR_USER')}</span>
      <br />
      {i18n.t('WHATSAPP_OPTIN_DISCLAIMER')}
    </div>
    <div>
      <br />
      <div>{i18n.t('WHATSAPP_OPTIN_DISCLAIMER_2')}</div>
    </div>
  </>
);

const WhatsappOptinActions = ({onSkip, onAccept}) => (
  <>
    <div className="whatsappOptin">
      <Button onClick={onSkip}>{i18n.t('SKIP')}</Button>
      <Button onClick={onAccept}>{i18n.t('YES_I_AM_INTERESTED')}</Button>
    </div>
    <div>
      <WhatsappOptinTnc />
    </div>
  </>
);

export const NonMfaWhatsappPreference = ({updateOptIn, onComplete}) => {
  return (
    <CustomCard
      class="whatsappPreferenceCard"
      cardBody={
        <div>
          <WhatsappCardHeader />
          <div className="whatsappPreferenceContent">
            <WhatsappDisclaimerContent />
            <WhatsappOptinActions
              onSkip={() => {
                updateOptIn(false);
                onComplete?.();
              }}
              onAccept={() => {
                updateOptIn(true);
                onComplete?.();
              }}
            />
          </div>
        </div>
      }
    />
  );
};

NonMfaWhatsappPreference.propTypes = {
  updateOptIn: PropTypes.func,
  onComplete: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
  updateOptIn: (optIn) => dispatch(updateNonMfaWhatsAppOptIn(optIn)),
});

export default connect(null, mapDispatchToProps)(NonMfaWhatsappPreference);
